/**
 * 具有权限的链接
 */
import React from 'react';
import styles from './index.scss'
export default class AuthLink extends React.Component {
    constructor(props) {
        super(props);

    }

    componentWillMount() {
    }

    componentDidMount() {

    }
    render() {
        let linkClass = "link";
        const {authKey} = this.props;
        linkClass+=authKey?" "+"inline": " "+"hide";
        return (
            <a className={linkClass} {...this.props}/>
        )
    }
}
